<template>
    <div class="data-wrapper-core">
        <h3>Kundenlogins</h3>
        <v-divider></v-divider>
        <v-expansion-panels class="customer-login-expansion-panels" multiple>
            <v-expansion-panel v-for="customerLogin in customerLogins" :key="customerLogin._id" rounded="lg">
                <v-expansion-panel-title>
                    <h4>{{ customerLogin.username }}</h4>
                    <v-spacer></v-spacer>
                    <!-- Trash Can Icon -->
                    <v-icon @click="openDeleteDialog(customerLogin._id)" color="red">mdi-trash-can</v-icon>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <p><strong>Passwort gesetzt: </strong>{{ customerLogin.passwordSet }}</p>
                    <p><strong>Passwort: </strong>{{ customerLogin.password }}</p>
                    <p><strong>Letzter Login: </strong>{{ customerLogin.lastSeen }}</p>
                    <p><strong>Kundenlogin-ID: </strong>{{ customerLogin._id }}</p>
                    <p v-if="customerLogin.excludedFrom">
                        <strong>Exkludiert von: </strong>{{ customerLogin.excludedFrom }}
                    </p>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>

        <!-- Delete Confirmation Dialog -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card rounded="lg" class="pa-3">
                <v-card-title class="headline">Kundenzugang löschen?</v-card-title>
                <v-divider class="pt-3 pb-3"></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green" text @click="closeDialog">Abbrechen</v-btn>
                    <v-btn color="red" variant="outlined" text @click="deleteCustomerLogin">Löschen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>



<script>
import { mapState, mapActions } from 'vuex';

export default {
    props: {
        customers: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            dialog: false,
            loginToDelete: null, // Keep track of which login to delete
        };
    },
    computed: {
        ...mapState('customer', ['customerLogins'])
    },
    methods: {
        ...mapActions('customer', ['deleteCustomerLogin']),
        ...mapActions('agency', ['saveLog']),
        openDeleteDialog(customerLoginId) {
            this.loginToDelete = customerLoginId;
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
            this.loginToDelete = null;
        },
        async deleteCustomerLogin() {
            const response = await this.$store.dispatch('customer/deleteCustomerLogin', this.loginToDelete);
            if (response && response.message === 'CustomerLogin deleted successfully.') {
                // If deletion was successful, log the action
                await this.$store.dispatch('agency/saveLog', {
                    agencyId: this.customers.ownerAgency,
                    changes: [
                        {
                            date: new Date(),
                            description: `Customerlogin deleted.`,
                            user: this.$store.state.loginAndOut.name
                        }
                    ],
                });
            }
            this.closeDialog();
        }
    },
};
</script>


<style lang="scss" scoped>
.customer-login-expansion-panels {
    margin: 8px 0;
}

.data-wrapper-core h3 {
    margin-bottom: 8px;
    font-size: 20px;
}

.v-icon {
    cursor: pointer;
}
</style>
